exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".image-container{position:relative;overflow:hidden}.image{width:100%;height:100%}.image.scale{transition:all .3s}.image.scale:hover{transform:scale(1.12)}.image-title{position:absolute;bottom:0;left:0;width:100%;height:.166667rem;line-height:.166667rem;padding:0 .104167rem;text-align:center;font-size:.072917rem;font-weight:700;color:#fff;background-color:rgba(0,0,0,.5);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border-radius:0 0 .03125rem .03125rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/px2rem-webpack-loader?{"baseDpr":1,"remUnit":192,"remPrecision":6,"forcePxComment":"px","keepComment":"no","remLimit":1,"exclude":{}}!./src/components/less/carouse-flexible.css
// module id = 929
// module chunks = 0